export default "__VITE_ASSET__voFdDb4k__"